import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { AppConfigModule } from '@nibtravel/shared/util/app-config';
import { ModelsModule } from '@nibtravel/shared/util/models';
import { UrlModule } from '@nibtravel/shared/util/url';

import { UnderwriterState } from './state/underwriter.state';
import { UnderwriterDataService } from './underwriter.data-service';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([UnderwriterState]),
    AppConfigModule,
    UrlModule,
    ModelsModule,
  ],
  providers: [UnderwriterDataService],
})
export class UnderwriterModule {}
